import {
  V2ListResourcesForAccountApiArg,
  useV2ListResourcesForAccountQuery,
} from "@generated";
import type { Resource } from "../types";

export interface UseResourcesListArgs {
  page?: V2ListResourcesForAccountApiArg["page"];
  filter?: V2ListResourcesForAccountApiArg["filter"];
}

export interface ResourcesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useResourcesList = ({ page, filter }: UseResourcesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListResourcesForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: Resource[] = (data?.data ?? []).map((r: any) => ({
    id: String(r.id),
    name: r.attributes?.name ?? "",
    externalName: r.attributes?.["external-name"] ?? "",
    description: r.attributes?.description ?? "",
    default: !!r.attributes?.default,
  }));

  const pageMeta: ResourcesListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useResourcesList;
